import { render, staticRenderFns } from "./ReportsProjects.view.vue?vue&type=template&id=7a09a4df&scoped=true&"
import script from "./ReportsProjects.view.vue?vue&type=script&lang=ts&"
export * from "./ReportsProjects.view.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsProjects.view.vue?vue&type=style&index=0&id=7a09a4df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a09a4df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDivider,VRow,VSkeletonLoader,VTextField})
